import clsx from 'clsx';

import { Modal } from '../../components';
import { JsonView, EmptyMessage } from '../../components';
import { formatDate, tryParseJSON } from '../../utilities';
import type { ContactStateType } from '../hooks/useViewContactState';

type ContactStateViewModalProps = {
  isOpened: boolean;
  state: ContactStateType[] | null;

  onClose: () => void;
};

type ContentProps = {
  state: ContactStateType[];
};

const prepareItem = (item: ContactStateType) => {
  return {
    state: item.state,
    state_details: tryParseJSON(item.state_details, true),
  };
};

const Content: React.FC<ContentProps> = ({ state }) => {
  if (!state.length) return <EmptyMessage>No items to display.</EmptyMessage>;

  return (
    <div className="flex flex-col">
      <div className="text-small mb-xl">
        Showing {state.length} state entries (most recent first)
      </div>
      <div className="flex flex-col gap-2xl">
        {state.map(item => {
          return (
            <div
              key={item.id}
              className={clsx(
                'flex flex-col gap-y-md',
                'pb-lg border-b border-active border-solid text-small text-textLight'
              )}
            >
              <div>
                <span className="font-semibold">Created: </span>
                {formatDate(item.created_at)}
              </div>
              <div>
                <span className="font-semibold">Workflow: </span>
                {item.workflow_id}
              </div>
              <JsonView value={prepareItem(item)} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

const ContactStateViewModal: React.FC<ContactStateViewModalProps> = ({
  state,
  isOpened,
  ...rest
}) => {
  const email = state?.[0]?.contact_email;

  return (
    !!state && (
      <Modal open={isOpened} title="Contact State Details" {...rest}>
        {!!email && (
          <div className="text-medium mb-sm">
            Contact State History: {email}
          </div>
        )}
        <Content state={state} />
      </Modal>
    )
  );
};

export default ContactStateViewModal;
